import './contact-map.scss';

export default function ContactMap() {
  return (
    <div className="map-agileits-w3layouts">
      <div className="address-left">
        <h4>Контакти</h4>
        <ul>
          <li>
            <i className="fa fa-map-marker"></i>ул. "Княз Борис I" №90
          </li>
          <li>
            <i className="fa fa-phone"></i>+359 2 988 75 71
          </li>
          <li>
            <i className="fa fa-mobile"></i>+359 878 63 74 12
          </li>
          <li>
            <a href="mailto:office@bsf.bg">
              <i className="fa fa-envelope-o"></i>office@bsf.bg
            </a>
          </li>
        </ul>
      </div>
      <iframe
        allowFullScreen
        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyB2NIWI3Tv9iDPrlnowr_0ZqZWoAQydKJU&q=%D1%83%D0%BB%D0%B8%D1%86%D0%B0%20%E2%80%9E%D0%9A%D0%BD%D1%8F%D0%B7%20%D0%91%D0%BE%D1%80%D0%B8%D1%81%20I%E2%80%9C%2090%2C%20Sofia%2C%20Bulgaria&maptype=roadmap"
      ></iframe>
    </div>
  );
}
